export const XD_LOADING_MODAL = 'xd_full_stock_loading';
export const XD_TASK_CHECK_MODAL = 'xd_task_check';
